import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { Dialog, DialogActions, DialogContent, Icon, IconButton, Typography } from "@material-ui/core";
import MultiSelectListBox from "react-multiselect-listbox";
import ButtonFooter from "components/ButtonFooter";
import SnackbarUtils from "utils/SnackbarUtils";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  centerContent: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogDepartment = (props) => {
  const { open, onClose, department, setDepartment, lookupDept } = props;
  const [tmpDept, setTmpDept] = useState(department);

  const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <Icon>close</Icon>
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        Select Department
      </DialogTitle>

      <DialogContent>
        <MultiSelectListBox
          className={"multi-select"}
          overrideStrings={{
            search: "Search...",
            selectAll: "Select All",
            removeAll: "Remove All",
            selectedInfo: "Items selected",
          }}
          sortable={true}
          options={lookupDept}
          textField="label"
          valueField="value"
          value={tmpDept}
          rowHeight={30}
          onSelect={({ item, sortedList }) => {
            setTmpDept(sortedList.map((i) => i.value));
          }}
          onRemove={({ item }) => {
            setTmpDept([...tmpDept.filter((i) => i !== item.value)]);
          }}
          onSelectAll={(selectedItems) => {
            if (selectedItems.length > 0) {
              const selected = [...tmpDept, ...selectedItems.map((item) => item.value)];
              setTmpDept(selected);
            }
          }}
          onRemoveAll={() => setTmpDept([])}
          onSort={({ sortedList }) => setTmpDept([...sortedList.map((i) => i.value)])}
          onSearch={({ items, textField, query }) =>
            items.filter((i) => i.label.toLowerCase().includes(query.toLowerCase()))
          }
        />
      </DialogContent>
      <DialogActions>
        <ButtonFooter
          noBorder
          SaveFnc={() => {
            if (tmpDept.length === 0) {
              SnackbarUtils.warning("Please select at least one department.");
              return false;
            }
            setDepartment(tmpDept);
            onClose();
          }}
          CancelFnc={() => {
            setDepartment(department);
            onClose();
          }}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDepartment;
